import styled from 'styled-components';

import type { InterstateTheme } from '@interstate/components/InterstateThemeProvider';

export const DealHeaderRoot = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    min-width: 0;
`;

export const DealHeaderTop = styled.div`
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.25rem 0.375rem;
    min-height: 1.75rem;
`;

export const PaymentGridControl = styled.span`
    display: inline-flex;
    margin-left: auto;
`;

export const DealTypeTitle = styled.h3`
    display: flex;
    flex-shrink: 0;
    align-items: center;
    gap: 0.25rem;
    margin: 0 auto 0 0;
    font: inherit;
`;

export const DealTypeTrigger = styled.button<{ theme: InterstateTheme }>`
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0;
    border: 0;
    background: none;
    font-family: inherit;
    font-size: 18px;
    font-weight: 500;
    line-height: 1.25;
    color: ${({ theme }) => theme.tokens.BaseColorBlue700};
    cursor: pointer;

    svg {
        width: 12px;
        height: 12px;
        transition: transform 0.2s;
    }

    &[aria-expanded='true'] svg {
        transform: rotate(180deg);
    }

    &:disabled {
        color: ${({ theme }) => theme.tokens.SemColorOnSurfaceInteractiveDisabled};
        cursor: not-allowed;
    }

    &:focus-visible {
        outline: 2px solid ${({ theme }) => theme.tokens.BaseColorBlue700};
        outline-offset: 2px;
    }
`;

export const PaymentSummaryRoot = styled.div<{ $isPrimary: boolean; theme: InterstateTheme }>`
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    gap: 0.25rem;
    padding: 0.375rem 0.5rem;
    border-radius: 4px;
    background-color: ${({ $isPrimary, theme }) =>
        $isPrimary ? theme.tokens.SemColorSurfaceDefault : theme.tokens.BaseColorGray50};
`;

export const SummaryAmount = styled.span`
    font-size: 18px;
    font-weight: 600;
    line-height: 1.25;
`;

export const SummaryUnit = styled.span<{ theme: InterstateTheme }>`
    font-size: 14px;
    color: ${({ theme }) => theme.tokens.SemColorOnSurfaceMuted};
`;

export const SummaryDetails = styled.ul<{ theme: InterstateTheme }>`
    display: inline-flex;
    flex-wrap: wrap;
    gap: 0.125rem;
    margin: 0;
    padding: 0;
    list-style: none;
    font-size: 12px;
    color: ${({ theme }) => theme.tokens.SemColorOnSurfaceMuted};

    li + li::before {
        content: '·';
        margin-right: 0.125rem;
        color: ${({ theme }) => theme.tokens.BaseColorGray300};
    }
`;

export const DEAL_TYPE_MENU_ID_PREFIX = 'scenario-deal-type';

export const MenuItemIcon = styled.span<{ theme: InterstateTheme }>`
    display: inline-flex;
    width: 1em;
    font-size: 14px;
    color: ${({ theme }) => theme.tokens.BaseColorBlue900};
`;

export const ProgramBadge = styled.span<{ theme: InterstateTheme }>`
    display: inline-block;
    max-width: 10rem;
    overflow: hidden;
    padding: ${({ theme }) => theme.tokens.ComponentBadgePadding};
    border-radius: ${({ theme }) => theme.tokens.ComponentBadgeBorderRadius};
    background-color: ${({ theme }) => theme.tokens.ComponentBadgeVariantSuccessBg};
    color: ${({ theme }) => theme.tokens.ComponentBadgeVariantSuccessColor};
    font-family: ${({ theme }) => theme.tokens.ComponentBadgeFontName};
    font-size: ${({ theme }) => theme.tokens.ComponentBadgeFontSize};
    font-weight: ${({ theme }) => theme.tokens.ComponentBadgeFontWeight};
    line-height: ${({ theme }) => theme.tokens.ComponentBadgeFontLineHeight};
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: middle;
`;
